import { CommonWidgetConfig } from '../../models';
import { WidgetDetails } from '../models';
import EditForm from './EditForm';
import Widget from './Widget';

export type Config = CommonWidgetConfig & { type: "command" };

export const details: WidgetDetails = {
    type: "command",
    name: "Command Widget"
  }
  
  export { EditForm, Widget };
